/* Haelt die Rapid-Search-Suchleiste beim Scrollen sichtbar (sticky).
   Die RPS-App koppelt das inline `top` der Leiste an die Unterkante des
   Dawn-Headers; scrollt der Sticky-Header aus dem Viewport, schiebt sie
   die Leiste mit auf top:-63px raus (Verhalten seit dem
   rps-csb-container-new Update der App, 2026-07). Wir klemmen top auf
   >= 0, damit die Leiste am oberen Viewport-Rand andockt, bis der
   Header (on-scroll-up) zurueckkommt. Added: 2026-07-17 */
(function () {
  var SEL = '.rps-csb-container';

  /* Unser fixes Geo-Sprachbanner (.akgeo, z-index 1000) belegt die
     obersten 54px — Leiste darunter andocken, sonst bei 0. */
  function floorPx() {
    var b = document.querySelector('.akgeo--show');
    if (!b) return 0;
    var r = b.getBoundingClientRect();
    if (getComputedStyle(b).position === 'fixed' && r.top <= 1 && r.height > 0) return r.bottom;
    return 0;
  }

  function clamp(bar) {
    var t = parseFloat(bar.style.top);
    var f = floorPx();
    if (!isNaN(t) && t < f) bar.style.top = f + 'px';
  }

  function watch(bar) {
    clamp(bar);
    new MutationObserver(function () { clamp(bar); })
      .observe(bar, { attributes: true, attributeFilter: ['style'] });
  }

  function init() {
    var bar = document.querySelector(SEL);
    if (bar) return watch(bar);
    var mo = new MutationObserver(function () {
      var b = document.querySelector(SEL);
      if (b) { mo.disconnect(); watch(b); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
